<template>
    <h1 v-if="!pokemon">Espere por favor...</h1>
    <div v-else="pokemon">
        <h1>¿Quién es este Pokémon?</h1>

        <pokemonPicture 
            :pokemon-id="pokemon.id" 
            :show-pokemon="showPokemon" />
        <PokemonOptions 
            :pokemons="pokemonArr"
            @selection-pokemon="checkAnswer"/>
        
        <template v-if="showAnswer">
            <h2 class="fade-in">{{ message }}</h2>
            <button @click="newGame">
                Nuevo Juego
            </button>
        </template>    
        
    </div>
</template>
<script>
import PokemonPicture from '@/components/PokemonPicture.vue'
import PokemonOptions from '@/components/PokemonOptions.vue'
import getPokemonOptions from '@/helpers/getPokemonOptions';

// console.log(getPokemonOptions());

export default {
    name: 'PokemonPage',
    components: {
        PokemonPicture,
        PokemonOptions
    },
    data(){
        return {
            pokemonArr: [],
            pokemon: null,
            showPokemon: false,
            showAnswer: false,
            message: ''
        }
    },
    methods: {
        async mixPokemonArray(){
            this.pokemonArr = await getPokemonOptions()
            
            const rndInt = Math.floor(Math.random() * 4)
            console.log(rndInt)
            this.pokemon = this.pokemonArr[rndInt]
        },
        checkAnswer( selectedId  ){
            // console.log('Pokemon Page llamado', pokemonId)
            this.showPokemon = true
            this.showAnswer = true

            if ( selectedId === this.pokemon.id ){
                this.message = `Correcto, ${ this.pokemon.name } es el Pokémon`
            }else{
                this.message = `Oops, ${ this.pokemon.name } es el Pokémon`
            }
            console.log('hola mundo', this.showPokemon)
        },
        newGame(){
            this.showPokemon = false
            this.showAnswer = false
            this.pokemon = null
            this.pokemonArr = []
            this.mixPokemonArray()
        }
    },
    mounted(){
        this.mixPokemonArray()
    }
}
</script>